import { useTranslation } from 'react-i18next'
import { toast } from '@/components/ui/toast'
import { ConfirmDeleteDialog } from '@/components/shared'
import { useDeleteClient } from '@/hooks/useClients'
import { getApiErrorMessage } from '@/services/api'
import type { Client } from '@/types'

interface Props {
  client: Client | null
  onClose: () => void
  onDeleted?: () => void
}

// 2.4.5 Delete client — Figma 8441:185752.
export function DeleteClientDialog({ client, onClose, onDeleted }: Props) {
  const { t } = useTranslation('clients')
  const del = useDeleteClient()

  const confirm = async () => {
    if (!client) return
    try {
      await del.mutateAsync(client.id)
      toast({ variant: 'success', title: t('delete.success') })
      onDeleted?.()
    } catch (e) {
      toast({
        variant: 'destructive',
        title: getApiErrorMessage(e, t('delete.error')),
      })
    }
  }

  return (
    <ConfirmDeleteDialog
      open={!!client}
      onOpenChange={o => !o && onClose()}
      title={t('delete.title')}
      description={t('delete.confirm')}
      confirmLabel={t('delete.confirmButton')}
      onConfirm={confirm}
      busy={del.isPending}
    />
  )
}
